import api from './api';

/**
 * @description Obtiene las notificaciones del usuario de forma paginada.
 * @param {number} page - El número de página a solicitar.
 * @param {number} limit - El número de notificaciones por página.
 * @returns {Promise<any>}
 */
const getNotifications = async (page = 1, limit = 5) => {
  try {
    const { data } = await api.get(
      `/notifications?page=${page}&limit=${limit}`
    );
    return data;
  } catch (error) {
    console.error(
      'Error al obtener las notificaciones:',
      error.response?.data || error.message
    );
    throw error.response?.data || new Error('Error del servidor');
  }
};

/**
 * @description Marca todas las notificaciones no leídas del usuario como leídas.
 * @returns {Promise<any>}
 */
const markAsRead = async () => {
  try {
    const { data } = await api.post('/notifications/read');
    return data;
  } catch (error) {
    console.error(
      'Error al marcar las notificaciones como leídas:',
      error.response?.data || error.message
    );
    throw error.response?.data || new Error('Error del servidor');
  }
};

const notificationService = {
  getNotifications,
  markAsRead,
};

export default notificationService;
